import { Price } from '../types';

export const isPriceZero = (price?: Price): boolean => !price?.min && !price?.max && !price?.fallback;
